
import fileDownload from 'js-file-download'
import axios from "axios";
let API_URL;
let API_BASE_URL;
let SITEURL;

const current_domain = window.location.hostname
console.log('host: ', current_domain)

API_URL = process.env.REACT_APP_API_URL
API_BASE_URL = process.env.REACT_APP_API_BASE_URL
SITEURL = process.env.REACT_APP_SITEURL
// console.log(SITEURL,API_URL, API_BASE_URL);


let helper = {
  ApiUrl:API_URL,
  ApiBaseUrl:API_BASE_URL,
  siteUrl : SITEURL,
  userTimezone : Intl.DateTimeFormat().resolvedOptions().timeZone,
  handleDownload : (url, filename,extension) => {
    axios.get(url, {
      responseType: 'blob',
    })
    .then((res) => {
      var file_name = filename+extension;
      fileDownload(res.data, file_name)
    })
  }
};

export default helper;
